import { PAYMENT_ENDPOINTS } from '../../../utils/api/endpoints/paymentEndpoints';
import {
  UseSignaturePaymentProspectParams,
  UseSignaturePaymentProspectResponse,
} from './useSignaturePaymentProspect.types';

const PREFIX = '[signaturePaymentProspectQuery]';

export const querySignaturePaymentProspect = async (params: UseSignaturePaymentProspectParams) => {
  console.log(PREFIX, `Fetching signature payment Prospect...`);
  const response = await PAYMENT_ENDPOINTS.signatureProspect(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received signature payment Prospect.`);
  return json as UseSignaturePaymentProspectResponse;
};
